import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=6ba434ba&scoped=true"
import script from "./AdminOrders.vue?vue&type=script&lang=js"
export * from "./AdminOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminOrders.vue?vue&type=style&index=0&id=6ba434ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba434ba",
  null
  
)

export default component.exports